import { render, staticRenderFns } from "./creditList.vue?vue&type=template&id=bf5a3506&scoped=true&"
import script from "./creditList.vue?vue&type=script&lang=js&"
export * from "./creditList.vue?vue&type=script&lang=js&"
import style0 from "./creditList.vue?vue&type=style&index=0&id=bf5a3506&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5a3506",
  null
  
)

export default component.exports